// extracted by mini-css-extract-plugin
export default {"lds-spinner":"Loading_lds-spinner__0QL9l"};